export const heroData = {
  title: "17.c 起草在线观看免费版",
  subtitle: "无需下载，即点即播，畅享高清影视体验",
  description: "17.c 起草在线观看免费版为您提供最新免费在线观看渠道。覆盖电影、电视剧、综艺、动漫等多种类型，支持高清播放、无广告干扰，随时随地享受流畅观影。",
  ctaText: "立即观看",
  ctaLink: "/category/recommend",
};

export const categories = [
  { name: "热门推荐", slug: "recommend", icon: "ri-fire-line", count: 128 },
  { name: "最新上映", slug: "new-release", icon: "ri-movie-2-line", count: 56 },
  { name: "电影", slug: "movie", icon: "ri-film-line", count: 320 },
  { name: "电视剧", slug: "tv-series", icon: "ri-tv-2-line", count: 245 },
  { name: "综艺", slug: "variety", icon: "ri-emotion-laugh-line", count: 180 },
  { name: "动漫", slug: "anime", icon: "ri-ghost-smile-line", count: 210 },
  { name: "纪录片", slug: "documentary", icon: "ri-camera-lens-line", count: 95 },
  { name: "少儿", slug: "kids", icon: "ri-user-smile-line", count: 78 },
];

export const hotVideos = [
  {
    id: 1,
    title: "最新热门大片 - 高清完整版",
    category: "热门推荐",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20scene%20with%20dramatic%20lighting%2C%20professional%20film%20production%20quality%2C%20warm%20golden%20and%20coral%20tones%2C%20theatrical%20composition%2C%20clean%20background%20with%20soft%20bokeh%20effects%2C%20entertainment%20industry%20aesthetic&width=600&height=340&seq=video-hot-01&orientation=landscape",
    rating: 9.2,
    views: "128万",
    tag: "热播",
  },
  {
    id: 2,
    title: "经典电视剧系列 - 全集在线播放",
    category: "电视剧",
    image: "https://readdy.ai/api/search-image?query=Television%20drama%20series%20scene%20with%20emotional%20actors%2C%20warm%20indoor%20lighting%2C%20soft%20amber%20and%20cream%20tones%2C%20cinematic%20framing%2C%20clean%20simple%20backdrop%2C%20high%20quality%20production&width=600&height=340&seq=video-hot-02&orientation=landscape",
    rating: 8.8,
    views: "256万",
    tag: "经典",
  },
  {
    id: 3,
    title: "爆笑综艺合集 - 笑到停不下来",
    category: "综艺",
    image: "https://readdy.ai/api/search-image?query=Variety%20show%20studio%20with%20colorful%20stage%20design%2C%20bright%20and%20energetic%20atmosphere%2C%20warm%20stage%20lighting%20with%20coral%20and%20golden%20accents%2C%20entertainment%20production%20aesthetic%2C%20clean%20background&width=600&height=340&seq=video-hot-03&orientation=landscape",
    rating: 9.0,
    views: "189万",
    tag: "爆笑",
  },
  {
    id: 4,
    title: "热血动漫连载 - 每周更新中",
    category: "动漫",
    image: "https://readdy.ai/api/search-image?query=Anime%20animation%20scene%20with%20vibrant%20colors%2C%20dynamic%20action%20composition%2C%20warm%20coral%20and%20golden%20tones%2C%20stylized%20Japanese%20animation%20aesthetic%2C%20clean%20minimal%20background%2C%20high%20quality%20art&width=600&height=340&seq=video-hot-04&orientation=landscape",
    rating: 9.5,
    views: "312万",
    tag: "连载",
  },
  {
    id: 5,
    title: "自然纪录片精选 - 震撼视觉之旅",
    category: "纪录片",
    image: "https://readdy.ai/api/search-image?query=Nature%20documentary%20cinematography%20with%20sweeping%20landscapes%2C%20warm%20natural%20lighting%2C%20golden%20hour%20tones%2C%20professional%20film%20quality%2C%20clean%20aesthetic%20background%2C%20epic%20scale&width=600&height=340&seq=video-hot-05&orientation=landscape",
    rating: 9.3,
    views: "95万",
    tag: "精选",
  },
  {
    id: 6,
    title: "最新国产剧 - 口碑爆棚之作",
    category: "电视剧",
    image: "https://readdy.ai/api/search-image?query=Chinese%20drama%20production%20scene%20with%20elegant%20costume%20design%2C%20warm%20ambient%20lighting%2C%20soft%20amber%20and%20cream%20tones%2C%20cinematic%20composition%2C%20clean%20artistic%20background%2C%20high%20production%20value&width=600&height=340&seq=video-hot-06&orientation=landscape",
    rating: 8.6,
    views: "178万",
    tag: "新剧",
  },
];

export const latestArticles = [
  {
    id: 1,
    title: "2026年最值得期待的十部大片，观影指南来了",
    summary: "2026年将有多部重磅大片上映，从科幻巨制到温情文艺片，我们为你整理了最值得期待的十部电影，附上详细的观影指南和上映时间表。",
    date: "2026-07-28",
    image: "https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20with%20film%20posters%20and%20warm%20ambient%20lighting%2C%20elegant%20golden%20and%20coral%20tones%2C%20modern%20cinema%20interior%20design%2C%20clean%20composition%2C%20professional%20photography&width=600&height=340&seq=article-01&orientation=landscape",
    views: "3.2万",
    tag: "观影指南",
  },
  {
    id: 2,
    title: "如何选择适合自己的在线播放平台？五个实用建议",
    summary: "市面上在线播放平台众多，画质、片源、速度各不相同。本文从五个维度帮你分析如何选择最适合自己的在线观看平台，少走弯路。",
    date: "2026-07-25",
    image: "https://readdy.ai/api/search-image?query=Modern%20streaming%20device%20setup%20with%20laptop%20and%20tablet%2C%20warm%20cozy%20ambient%20lighting%2C%20soft%20amber%20and%20cream%20tones%2C%20clean%20minimal%20desk%20setup%2C%20lifestyle%20technology%20photography&width=600&height=340&seq=article-02&orientation=landscape",
    views: "1.8万",
    tag: "使用技巧",
  },
  {
    id: 3,
    title: "高清观影体验提升指南：从设备到网络全面优化",
    summary: "想要享受极致的观影体验？除了好的片源，设备选择和网络优化同样重要。我们将从硬件、软件、网络三个方面，教你如何打造家庭影院级观影环境。",
    date: "2026-07-22",
    image: "https://readdy.ai/api/search-image?query=Home%20theater%20setup%20with%20large%20screen%20display%2C%20warm%20ambient%20lighting%2C%20cozy%20living%20room%20atmosphere%2C%20soft%20golden%20and%20coral%20tones%2C%20clean%20modern%20interior%2C%20entertainment%20technology&width=600&height=340&seq=article-03&orientation=landscape",
    views: "2.5万",
    tag: "观影指南",
  },
];

export const faqData = [
  {
    question: "17.c 起草在线观看免费版是否需要注册？",
    answer: "17.c 起草在线观看免费版无需注册即可免费在线观看。我们致力于为用户提供便捷的观影体验，无需繁琐的账号注册流程，打开即看，方便快捷。部分高级功能可能需要简单验证。",
  },
  {
    question: "17.c 起草在线观看免费版支持哪些设备？",
    answer: "17.c 起草在线观看免费版全面支持电脑、平板、手机等多种设备。网页端采用响应式设计，自动适配不同屏幕尺寸，无论在哪种设备上都能获得流畅的观影体验。支持Windows、Mac、iOS、Android等主流操作系统。",
  },
  {
    question: "为什么叫17.c 起草？有什么含义？",
    answer: "17.c 起草是一个专注于影视内容聚合与在线观看的平台品牌。'起草'寓意着我们从内容筛选到播放体验的每一个环节都精心打磨，为用户提供高质量的影视观看服务。平台持续更新最新影视资源，确保用户始终能看到最新、最全的内容。",
  },
  {
    question: "播放过程中遇到卡顿怎么办？",
    answer: "如果播放过程中遇到卡顿，建议尝试以下方法：1）检查网络连接是否稳定；2）尝试切换不同的播放线路（平台提供多条线路备选）；3）降低画质设置；4）清理浏览器缓存后重试。大部分卡顿问题都可以通过这些方法解决。",
  },
  {
    question: "17.c 起草在线观看免费版的内容更新频率如何？",
    answer: "17.c 起草在线观看免费版每日更新大量影视内容，包括最新上映的电影、热播电视剧、综艺节目和动漫连载等。我们的内容团队会第一时间同步最新资源，确保用户不会错过任何精彩内容。周末和节假日会有额外的特别推荐。",
  },
  {
    question: "观看过程中有广告吗？",
    answer: "17.c 起草在线观看免费版致力于提供清爽无广告的观影体验。我们采用先进的播放技术，最大限度减少广告干扰，让用户专注于观影本身。相比其他平台，17.c 起草的广告频率显著更低，观影体验更加流畅舒适。",
  },
];